import produce from 'immer';

import {
  EXECUTIVE_REPORT_EMBED_URL_FETCH_FAILURE,
  EXECUTIVE_REPORT_EMBED_URL_FETCH_REQUEST,
  EXECUTIVE_REPORT_EMBED_URL_FETCH_SUCCESS,
  EXECUTIVE_REPORTS_LIST_FETCH_FAILURE,
  EXECUTIVE_REPORTS_LIST_FETCH_SUCCESS,
} from '@actions/executiveReports';

const initialState: IExecutiveReportsStore = {
  currentReportEmbedURL: null,
  executiveReportsList: [],
  error: null,
};

export default (state: IExecutiveReportsStore = initialState, action: any) =>
  produce(state, (draftState: IExecutiveReportsStore) => {
    switch (action.type) {
      case EXECUTIVE_REPORT_EMBED_URL_FETCH_REQUEST:
        draftState.currentReportEmbedURL = null;
        draftState.error = null;

        return;

      case EXECUTIVE_REPORTS_LIST_FETCH_SUCCESS:
        draftState.executiveReportsList = action.response;
        draftState.error = null;

        return;

      case EXECUTIVE_REPORT_EMBED_URL_FETCH_SUCCESS:
        draftState.currentReportEmbedURL = action.response.embedURL;
        draftState.error = null;

        return;

      case EXECUTIVE_REPORT_EMBED_URL_FETCH_FAILURE:
      case EXECUTIVE_REPORTS_LIST_FETCH_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
